export default "/static/dashboard/build/app/img/v2/0958256e90371137ae57050290e909d9.png";